<a
  [routerLink]="['/product-details', product.slug]"
  class="game-card"
  *ngIf="product"
>
  <div class="game-card__image-container">
    <img
      class="game-card__image"
      [src]="mainAsset?.preview || 'assets/images/flash-discounts/card-cover-image.svg'"
      [alt]="product.name"
    />
    <div class="game-card__discount-badge" *ngIf="discountPercentage > 0">
      -{{ discountPercentage }}%
    </div>
  </div>
  <div class="game-card__content">
    <h3 class="game-card__title">{{ product.name }}</h3>
    <p class="game-card__store">Microsoft or Xbox store</p>
    <div class="game-card__bottom">
      <div class="game-card__platforms">
        <span
          *ngFor="let platform of visiblePlatforms"
          class="game-card__platforms__platform-icon"
          nz-icon
          [nzType]="platform.icon"
        >
        </span>
        <span
          *ngIf="hasMorePlatforms"
          class="game-card__platforms__platform-icon game-card__platforms__platform-icon--more"
        >
          +{{ remainingPlatformsCount }}
        </span>
      </div>
      <div class="game-card__price-info">
        <span class="game-card__original-price" *ngIf="discountPercentage > 0">
          ${{ product.variants[0].price | number: '1.2-2' }}
        </span>
        <span class="game-card__current-price">
          ${{ calculateDiscountedPrice(product.variants[0].price) | number: '1.2-2' }}
        </span>
      </div>
    </div>
  </div>
</a>

<div class="desktop-skeleton" *ngIf="!product"></div>
